export const EVENT_TYPE_SCHEDULED = 1;
export const EVENT_TYPE_AVAILABLE = 2;

